import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type InitialStateProps = {
	hoverMenuIsOpened: boolean
	lastOpenCategory: string
}

const initialState = {
	hoverMenuIsOpened: false,
	lastOpenCategory: ``
} as InitialStateProps

const header = createSlice({
	name: `header`,
	initialState,
	reducers: {
		setHoverMenuIsOpened: (state, action: PayloadAction<boolean>) => {
			state.hoverMenuIsOpened = action.payload
		},
		setLastOpenCategory: (state, action: PayloadAction<string>) => {
			state.lastOpenCategory = action.payload
		}
	}
})

export const { setHoverMenuIsOpened, setLastOpenCategory } = header.actions
export default header.reducer
